import React, {useMemo, useState} from "react";

import { Table, Row, Col, Button, Tooltip, TablePaginationConfig, Modal } from "antd";
import { EnrollmentFormModel } from "models/EnrollmentForm";

import { Column, EnrollmentFormsGeneratedProps } from "./EnrollmentForms.props";
import { ButtonRow, Container, StyledSpace } from "./EnrollmentForms.style";
import { BarChartOutlined, DeleteOutlined, EditOutlined, InboxOutlined, FormOutlined, EyeOutlined } from "@ant-design/icons";


export type LinksMessageComponentProps = {
 id: string,
 baseUrl: string,
 surveyId: any,
 ceoEmail: string,
 employeeEmails: any[]
};
const LinksMessageComponent = ({baseUrl='', surveyId={}, id='', ceoEmail='', employeeEmails=[]}: LinksMessageComponentProps): JSX.Element => {
  const columns = useMemo(
    () => [
      { key: 'email', title: 'Email', dataIndex: 'email'  },
      { key: 'link', title: 'Link',  dataIndex: 'uri', render: (uri: string) => <a target="_blank" href={encodeURI(uri)}>Open</a> }
    ],
    []
  );
  const dataset: any = [...new Set([ceoEmail, ...employeeEmails])].map((email) => ({
    email,
    uri: `${baseUrl}/answer-survey?surveyId=${surveyId?.id || surveyId?.name}&enrollmentFormId=${id}&email=${btoa(email)}`
  }));
  return (<Table columns={columns} dataSource={dataset} />);
};

const EnrollmentFormsView = (
  props: EnrollmentFormsGeneratedProps
): JSX.Element => {
  const show = ({id='', surveyId={}, ceoEmail='', employeeEmails=[]}: LinksMessageComponentProps) => {
    Modal.info({
      title: 'Assessment links',
      centered: true,
      width: 500,
      content: <LinksMessageComponent
        id={id}
        surveyId={surveyId}
        ceoEmail={ceoEmail}
        employeeEmails={employeeEmails}
        baseUrl={process.env.PUBLIC_URL}
      />
    });
  };

  const columns: Column[] = useMemo(
    () => [
      {
        title: 'Company Name',
        dataIndex: 'companyName',
      },
      {
        title: 'CEO First Name',
        dataIndex: 'ceoName',
      },
      {
        title: 'CEO Last Name',
        dataIndex: 'ceoLastName',
      },
      {
        title: 'CEO Email',
        dataIndex: 'ceoEmail',
      },
      {
        title: 'CEO Contact Number',
        dataIndex: 'ceoContactNumber',
      },
      {
        title: 'Company Address',
        dataIndex: 'companyAddress',
      },
      {
        title: 'Company Website URL',
        dataIndex: 'companyWebsiteUrl',
      },
    ],
    []
  );

  console.log('EnrollmentFormsView: ', { 'data': props.data });
  return (<>
    <Container>
      <StyledSpace direction="vertical" size={16}>
        <Row justify="end">
          <Button
            type="primary"
            onClick={props.onClickCreate}
            style={{ marginRight: "8px" }}
          >
            Create Enrollment Form
          </Button>
          <Button onClick={props.onClickSendEnrollmentForm}>
            Send Enrollment Form
          </Button>
        </Row>
        <Table
          loading={props.loading}
          dataSource={props.data}
          // onChange={props.onChange}
          rowKey="id"
        >
          {columns.map(col => <Table.Column key={col.dataIndex} {...col} />)}

          <Table.Column
            title={"Actions"}
            dataIndex={"id" as keyof EnrollmentFormModel}
            width={180}
            render={(id, row) => (
              <ButtonRow>
                <Tooltip placement="top" title="View assessment links">
                  <Button type="primary" onClick={() => {show(row as LinksMessageComponentProps);}}>
                    <EyeOutlined />
                  </Button>
                </Tooltip>

                <Tooltip placement="top" title="View Diagnostic">
                  <Button type="primary" onClick={() => props.onClickViewDiagnostic(id)}>
                    <BarChartOutlined rotate={90} style={{ transform: 'scale(1, -1)' }}/>
                  </Button>
                </Tooltip>

                <Tooltip placement="top" title="Edit CEO enrollment">
                  <Button type="primary" onClick={() => props.onClickEditEnrollmentForm(id)}>
                    <EditOutlined />
                  </Button>
                </Tooltip>
                <Tooltip placement="top" title="Edit CEO assessment">
                  <Button type="primary" onClick={() => props.onClickEditSurveyForm(id)}>
                    <FormOutlined />
                  </Button>
                </Tooltip>

                <Tooltip placement="top" title="Archive">
                  <Button onClick={() => props.onClickArchiveRecord(row as EnrollmentFormModel)}>
                    <InboxOutlined />
                  </Button>
                </Tooltip>

                <Tooltip placement="top" title="Delete">
                  <Button onClick={() => props.onClickDeleteRecord(row as EnrollmentFormModel)}>
                    <DeleteOutlined />
                  </Button>
                </Tooltip>
              </ButtonRow>
            )}
          />
          <Table.Column
            title={'Code'}
            dataIndex={'id' as keyof EnrollmentFormModel}
            width={100}
            render={(id, row) => {
              return (<pre>{JSON.stringify(row)}</pre>);
            }}
          />
        </Table>
      </StyledSpace>
    </Container>
  </>);
};

export default EnrollmentFormsView;

